import React, { useRef, useState } from 'react';
import { Button, Form, Image } from 'react-bootstrap';
import LoadingComponent from '../LoadingComponent';
import config from '../../Api/config';
import { useRppsUploadMutation } from './doctorApi';
import Swal from 'sweetalert2';

const RppsUpload = ({ email, image }) => {
    const fileInputRef = useRef(null);
    const [preview, setPreview] = useState(
        image ? `${config.API_URL}/${image}` : null
    );
    const [loading, setLoading] = useState(false);
    const [rppsUpload] = useRppsUploadMutation();

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = async (event) => {
        if (!event.target.files[0]) return;

        setLoading(true);
        const previewUrl = URL.createObjectURL(event.target.files[0]);
        setPreview(previewUrl);

        let formData = new FormData();
        formData.append('UserEmail', email);
        formData.append('SignatureImage', event.target.files[0]);

        try {
            const response = await rppsUpload(formData);

            // Check if the response contains data and indicates success
            if (response.data?.success) {
                // Adjust based on your API response structure
                Swal.fire({
                    title: 'Succès!',
                    text: 'Document RPPS téléchargé avec succès',
                    icon: 'success',
                    confirmButtonText: 'OK',
                    timer: 3000,
                    timerProgressBar: true,
                });
            } else {
                // Handle API response that is not successful
                Swal.fire({
                    title: 'Erreur!',
                    text:
                        response.data?.message ||
                        'Échec du téléchargement du document RPPS',
                    icon: 'error',
                    confirmButtonText: 'OK',
                });
                // Reset preview if upload fails
                setPreview(image ? `${config.API_URL}/${image}` : null);
            }
        } catch (error) {
            console.error('Upload failed:', error);
            Swal.fire({
                title: 'Erreur!',
                text: 'Une erreur est survenue lors du téléchargement',
                icon: 'error',
                confirmButtonText: 'OK',
            });
            // Reset preview on error
            setPreview(image ? `${config.API_URL}/${image}` : null);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            {loading && <LoadingComponent />}

            <Image src={preview} rounded />
            <Button
                variant="primary"
                className="mt-3"
                onClick={handleButtonClick}
            >
                Télécharger RPPS
            </Button>
            <Form.Control
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
                accept="image/*,.pdf" // Added PDF support for documents
            />
        </div>
    );
};

export default RppsUpload;
